import { useState } from 'react'
import { useIntl } from '@/intl'

export const useTexts = () => {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    headerTitle: translate({ id: 'settings.personalization.view.headerTitle' }),
    headerDescription: translate({ id: 'settings.personalization.view.headerDescription' }),
  }))

  return api
}
